import SHA256 from 'crypto-js/sha256';

const createHash = (str: string) => SHA256(str).toString();

export default createHash;
